import { useState, useRef, useEffect } from "react";
import { Uploader, Button } from "rsuite";
import uploadIcon from "../../../assets/icons/file-upload-icon.svg";
import styles from "./fileUpload.module.scss";
import { postData } from "../../../utils/reusables";
import { uploadResponseProps } from "../../../pages/contentUpload/contentUpload";
import { FileType } from "rsuite/esm/Uploader";

type uploaderProps = {
  btnName: string;
  setUploadResponse: (value: uploadResponseProps[]) => void;
  triggerNotification: (value: boolean, message: string) => void;
  countryId: number | unknown;
  url: string;
  windowWidth: number;
};

const FileUpload = ({
  btnName,
  setUploadResponse,
  triggerNotification,
  countryId,
  url,
  windowWidth,
}: uploaderProps) => {
  const [uploading, setUploading] = useState<boolean>(false);
  let [currentFile, setCurrentFile] = useState<FileType[] | []>([]);

  const uploader = useRef<HTMLInputElement>(null);

  const handleFileUpload = async () => {
    const formData = new FormData();
    const modifiedResponse: {
      status: string;
      type: string;
      message: string;
    }[] = [];

    if (!currentFile[0].name?.endsWith(".xlsx")) {
      const response = {
        status: "false",
        type: "Error",
        message: "Only .xlsx files are allowed",
      };
      modifiedResponse.push(response);
      setUploadResponse(modifiedResponse);
      setUploading(false);
      return;
    }

    if (countryId) {
      formData.append("countryId", String(countryId));
      formData.append("file", currentFile[0].blobFile as Blob);

      postData(url, formData)
        .then((result) => {
          if (result.status === 200) {
            if (result.data.length > 0) {
              for (let i = 0; i < result.data.length; i++) {
                const response = {
                  status: String(result.data[i].status),
                  type: result.data[i].type,
                  message: result.data[i].message,
                };
                modifiedResponse.push(response);
              }
            } else if (result.data.length === 0) {
              const response = {
                status: "true",
                type: "Success",
                message: "File successfully uploaded",
              };
              modifiedResponse.push(response);
            }
            setUploadResponse(modifiedResponse);
          } else {
            const response = {
              status: String(result.data.StatusCode),
              type: result.data.type,
              message: result.data.Message,
            };
            modifiedResponse.push(response);
            setUploadResponse(modifiedResponse);
          }
        })
        .then(() => setUploading(false));
    } else {
      triggerNotification(false, "Please Select Country");
      setUploading(false);
    }
  };

  useEffect(() => {
    setCurrentFile([]);
    setUploadResponse([]);
  }, [countryId, setUploadResponse]);

  return (
    <div>
      <div className="row pb-2 position-relative">
        {!countryId && (
          <div className={"position-absolute uploader-overlay col-12"}></div>
        )}
        {currentFile.length > 0 && (
          <div className={"position-absolute uploader-overlay col-12"}></div>
        )}
        <div className="col-lg-8 col-md-12 col-12 content-upload">
          <Uploader
            autoUpload={false}
            removable={!uploading}
            action={url}
            accept=".xlsx"
            draggable
            fileList={currentFile}
            multiple={false}
            onChange={setCurrentFile}
            ref={uploader}
            onRemove={() => {
              setCurrentFile([]);
              setUploadResponse([]);
            }}
            disabled={currentFile.length > 0}
            renderFileInfo={(file) => {
              return (
                <div
                  className={`${
                    currentFile.length !== 1 ? "d-none" : "d-flex"
                  }`}
                >
                  <div>
                    <h3>{file.name}</h3>
                  </div>
                </div>
              );
            }}
          >
            <div
              className="d-flex flex-wrap"
              style={{ width: windowWidth / 4 }}
            >
              <div className={`${styles.uploadWrapper} me-4`}>
                <img
                  src={uploadIcon}
                  alt=""
                  className={`${styles.uploadIcon} w-100`}
                />
              </div>
              <div className="text-center">
                <h4 className={currentFile.length > 0 ? "fs-6" : ""}>
                  {!countryId
                    ? "Select a country to enable content-upload"
                    : currentFile.length > 0
                    ? "Remove current file or change country to enable content-upload"
                    : "Drag and drop files here"}
                </h4>
                <h3
                  className={
                    countryId === null || currentFile.length > 0
                      ? "d-none"
                      : "py-2"
                  }
                >
                  Or,
                </h3>
                <Button
                  disabled={currentFile.length === 1 || countryId === null}
                  className={
                    countryId === null || currentFile.length > 0
                      ? "d-none"
                      : "primary-color"
                  }
                  appearance="primary"
                >
                  Browse Files
                </Button>
              </div>
            </div>
          </Uploader>
        </div>

        <div className="mt-auto col-lg-4 col-md-12 col-12">
          <Button
            disabled={!currentFile.length || uploading}
            loading={uploading}
            onClick={() => {
              setUploading(true);
              handleFileUpload();
            }}
            appearance="primary"
            className={`${
              currentFile.length === 1 ? "px-4 my-2 publish-btn" : "d-none"
            }`}
          >
            {btnName}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
